'use client';

import { FacebookShareButton, TwitterShareButton } from 'react-share';
import { useToast } from '@get-mosh/msh-shared';
import styles from './social-media-share.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faLink } from '@fortawesome/pro-solid-svg-icons';
import { SliceComponentProps } from '@prismicio/react';
import { Content } from '@prismicio/client';

const MOSH_BLOG_URL = 'https://www.getmosh.com.au/blog/';

type SocialMediaShareProps =
    SliceComponentProps<Content.SocialMediaShareSlice> & {
        context: {
            uid: string;
        };
    };

const SocialMediaShare = ({ context }: SocialMediaShareProps) => {
    const url = MOSH_BLOG_URL + context.uid;
    const { showToast } = useToast();

    const copyToClipboard = async () => {
        await navigator.clipboard.writeText(url);
        showToast({ title: 'Link copied to clipboard' });
    };

    return (
        <section className="mt-6 px-4">
            <h3 className={styles['share__header']}>Share</h3>
            <div className={styles['share__buttons']}>
                <button onClick={() => copyToClipboard()}>
                    <FontAwesomeIcon icon={faLink} width={14} height={14} />
                </button>
                <FacebookShareButton url={url}>
                    <FontAwesomeIcon icon={faFacebookF} />
                </FacebookShareButton>
                <TwitterShareButton url={url}>
                    <FontAwesomeIcon icon={faTwitter} />
                </TwitterShareButton>
            </div>
        </section>
    );
};
export default SocialMediaShare;
